"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalTemplate = useLocalTemplate;
const packageJson = require("../../../package.json");
/**
 * Determines whether to use local templates based on environment variables and package version.
 * Returns true if:
 * - TEMPLATE_VERSION env variable is set to "local", OR
 * - Package version contains "alpha" (daily build version)
 */
function useLocalTemplate() {
    const templateVersionEnv = process.env["TEMPLATE_VERSION"];
    if (templateVersionEnv === "local") {
        return true;
    }
    const version = packageJson.version;
    if (version.includes("alpha")) {
        // daily build version
        return true;
    }
    return false;
}
//# sourceMappingURL=templateHelper.js.map